<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xiv"></a><a id="page_xv"></a>Gadamer and the<br/>Transmission of History</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?14bf8278